import React from "react";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import AssignmentIcon from '@material-ui/icons/Assignment';
import List from "@material-ui/core/List";
import Tooltip from "@material-ui/core/Tooltip";
import BusinessIcon from "@material-ui/icons/Business";
import history from "utils/History";
import AccountBoxIcon from "@material-ui/icons/AccountBox";
import PlaylistAddCheckIcon from '@material-ui/icons/PlaylistAddCheck';
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks';
import CollectionsBookmarkIcon from '@material-ui/icons/CollectionsBookmark';
import PersonIcon from '@material-ui/icons/Person';
import useAuth from "hooks/Auth";
import Roles from "constants/Roles";
import SchoolIcon from "@material-ui/icons/School";
import BrandingWatermarkIcon from "@material-ui/icons/BrandingWatermark"; 
import AccountTreeIcon from "@material-ui/icons/AccountTree";
import Group from "@material-ui/icons/Group";
import BusinessCenterIcon from  "@material-ui/icons/BusinessCenter";
import AssistantPhotoIcon from  "@material-ui/icons/AssistantPhoto";
import GroupIcon from   "@material-ui/icons/Group";
import PersonAdd from   "@material-ui/icons/PersonAdd";
import SettingsIcon from '@material-ui/icons/Settings';
import ListIcon from '@material-ui/icons/List';
import SearchIcon from '@material-ui/icons/Search';

const menuOptions = [
  {
    path: "convenios",
    title: "Convenios",
    icon: <AssignmentIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "sedesSelection",
    title : "Sedes",
    icon: <BusinessIcon />,
    rolesRequired: [Roles.ROLE_USER]
  },
  {
    path: "carreras",
    title : "Carreras",
    icon: <LibraryBooksIcon />,
    rolesRequired: [Roles.ROLE_DNERHS]
  },
  // Profesionales de la salud.
  {
    path: "carreras-postgrado",
    title : "Programas de Postgrado..",
    icon:  <CollectionsBookmarkIcon />,
    rolesRequired: [ Roles.ROLE_DNERHS]
  },
  {
    path: "constancias",
    title: "Constancias",
    icon: <PlaylistAddCheckIcon />,
    rolesRequired: [Roles.ROLE_USER]
  },
  {
    path: "establecimientos",
    title: "Establecimientos",
    icon: <BusinessIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "establecimientos/responsables",
    title: "Responsables Establecimientos",
    icon: <PersonIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "responsables",
    title: "Solicitud Responsables",
    icon: <AccountBoxIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "institucionesFormadoras",
    title: "Instituciones Formadoras",
    icon:  <SchoolIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "nombres-servicios",
    title: "Nombres Servicios",
    icon:  <BrandingWatermarkIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "niveles-servicios",
    title: "Niveles Servicios",
    icon:  <AccountTreeIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "profesiones",
    title: "Profesiones",
    icon:  <BusinessCenterIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
  {
    path: "practicas",
    title : "Prácticas de estudiantes",
    icon:  <AssistantPhotoIcon />,
    rolesRequired: [ Roles.ROLE_DNERHS]
  },
  {
    path: "practicas-convenio",
    title: "Listado de Prácticas",
    icon: <ListIcon />,
    rolesRequired: [Roles.ROLE_DNERHS]
  },
  {
    path: "consulta-plazas",
    title: "Consulta de Plazas",
    icon: <SearchIcon />,
    rolesRequired: [Roles.ROLE_ADMIN, Roles.ROLE_DNERHS]
  },
   
  // Profesionales de la salud.
  {
    path: "profesionales-salud",
    title : "Profesionales de la salud",
    icon:  <GroupIcon />,
    rolesRequired: [ Roles.ROLE_DNERHS]
  },
  {
    path: "usuarios",
    title : "Usuarios",
    icon:  <PersonAdd />,
    rolesRequired: [ Roles.ROLE_DNERHS]
  },
  {
    path: "configuraciones",
    title : "Configuraciones",
    icon:  <SettingsIcon />,
    rolesRequired: [ Roles.ROLE_DNERHS]
  }
]

const Menu = () => {
  const { userData } = useAuth();

  const handleClickLink = (path) => {
    history.push(`/${path}`);
  };

  const filterMenuOptions = (menu) => {
    return menu.rolesRequired.length === 0 || menu.rolesRequired.includes(userData?.roleName)
  }

  return (
    <>
      <List>
        {
          menuOptions.filter(filterMenuOptions).map((menu, index) => (
            <ListItem
              key = {index}
              button
              onClick={() => handleClickLink(menu.path)}
            >
              <ListItemIcon>
                <Tooltip title={menu.title}>
                  {menu.icon}
                </Tooltip>
              </ListItemIcon>
              <ListItemText primary={menu.title} />
            </ListItem>
          ))
        }
      </List>
    </>
  );
};

export default Menu;
